import { connect } from 'react-redux';

import SelectMediaFromLibrary from 'zoomforth_component_lib/select_media_from_library.jsx';

import {
  closeModal
} from 'zoomforth_codesbane_editor/action_creators/editor_modals.js';



const mapStateToProps = (state) => {
  return {};
};


const mapDispatchToProps = (dispatch, { onAssetsSelectDone, onAssetsSelectFail }) => (
  {
    onAssetsSelect: (assets)=> { 
      // If they select no assets then we can ignore this step
      if (assets) {
        onAssetsSelectDone(assets);
      }
      dispatch(closeModal());
    },
    onAssetsSelectFail: () => {
      if (onAssetsSelectFail) {
        onAssetsSelectFail();
      }
      dispatch(closeModal());
    }
  }
);

const SelectMediaFromLibraryModal = connect(
  mapStateToProps,
  mapDispatchToProps

)(SelectMediaFromLibrary);

SelectMediaFromLibraryModal.editorModalName = 'SelectMediaFromLibraryModalContainer';

export default SelectMediaFromLibraryModal;